import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const Header = ({ title }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="header">
      <h1>{title}</h1>
      <div className="user-info">
        <span>Welcome, {user?.full_name || user?.username}</span>
        <button onClick={handleLogout} className="secondary">
          Logout
        </button>
      </div>
    </div>
  );
};

export default Header;